import React from 'react';
import { Text, Platform } from './ReactNativeCore'; // Import Text and Platform from ReactNativeCore

interface MaterialCommunityIconsProps {
  name: string;
  size?: number;
  color?: string;
}

// Web fallback for MaterialCommunityIcons
const WebMaterialCommunityIcons: React.FC<MaterialCommunityIconsProps> = ({
  name,
  size = 24,
  color = 'black',
}) => {
  return <span style={{ fontSize: size, color, verticalAlign: 'middle' }}>[MCI-Icon: {name}]</span>; // Use span for web
};

export const MaterialCommunityIcons: React.FC<MaterialCommunityIconsProps> = Platform.OS === 'web' ? WebMaterialCommunityIcons : ({
  name,
  size = 24,
  color = 'black',
}) => {
  // For non-web, keep the simple Text placeholder.
  return <Text style={{ fontSize: size, color }}>[MCI-Icon: {name}]</Text>;
};
